import React from 'react';
import { Grid, Button, Paper } from '@material-ui/core'

const TextResult = (result) => {
  result = result.result
  let resStatus = result.status === true ? 'Success' : 'Failure'

  return (
    <Grid container justifyContent="center" alignContent="center" item xs={12} style={{padding: '8px'}}>
      <span>({result.rloc}) {result.to}:</span>
      <span style={{color: resStatus === 'Success' ? 'green' : 'red'}}>{resStatus}</span>
    </Grid>
  )
}

const SendingText = (props) => {
  const modalClasses = props.modalClasses
  const closeModal = props.closeModal
  const textResults = props.textResults

  if (textResults === 'sending') {
    return (
      <Paper className={modalClasses.sendTextStatusPaper}>
        <Grid container item xs={12} justify="center">
          <h3>Sending...</h3>
        </Grid>
        <Grid container item xs={12} justify="center" style={{paddingBottom: '5px'}}>
          <Button variant="contained" onClick={() => {closeModal(false)}} style={{backgroundColor: '#eb494e'}}>Close</Button>
        </Grid>
      </Paper>
    )
  }
  else if (Array.isArray(textResults) && textResults.length > 0) {
    return (
      <Paper className={modalClasses.sendTextStatusPaper}>
        <Grid container item xs={12} justify="center">
          {textResults.map((result, index) => (
            <TextResult result={result} key={result?.sid || ('text-result-' + index)} />
          ))}
        </Grid>
        <Grid container item xs={12} justify="center" style={{paddingBottom: '5px'}}>
          <Button variant="contained" onClick={() => {closeModal(false)}} style={{backgroundColor: '#eb494e'}}>Close</Button>
        </Grid>
      </Paper>
    )
  }
  else if (textResults === 'failure') {
    return (
      <Paper className={modalClasses.sendTextStatusPaper}>
        <Grid container item xs={12} justify="center">
          <h3>Failure</h3>
        </Grid>
        <Grid container item xs={12} justify="center" style={{paddingBottom: '5px'}}>
          <Button variant="contained" onClick={() => {closeModal(false)}} style={{backgroundColor: '#eb494e'}}>Close</Button>
        </Grid>
      </Paper>
    )
  }
  else {
    return (
      <div>hmm</div>
    )
  }
}

export default SendingText